export default {
	pricelistList: [],
	pricelistEdit: '',
	priceTableAll: [],
	priceTableAllSelected: [],
	priceTableList: [],
	priceTableListFirst: [],
	priceTableSelect: [],
	isLibraryUpdate: false,
	libraryDetails: [],
	libraryLoading: false,
	undefinedImport: [],
	nonImport: [],
  stockData: [],
  importingData: false
}
